import { z } from 'zod';

export const UserId = z.string().brand('UserId');
export const User = z.object({
  id: UserId,
  name: z.string(),
  avatarURL: z.string().url().optional(),
  bio: z.string(),
  role: z.enum(['leader', 'normal']),
  lastLoginAt: z.string().datetime({ offset: true }),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});

export type UserType = z.infer<typeof User>;

export const UserSummary = User.pick({
  id: true,
  name: true,
  role: true,
  lastLoginAt: true,
});

export type UserSummaryType = z.infer<typeof UserSummary>;
